/* Shuffle the ties in a PIS-ranked grid.

   The catalogue ranks every piece with a Product Importance Score, and the
   server renders each grid in that order. But the score is not a total order:
   27 pieces share 57.7, 23 share 50.5, 11 share 48.3 -- 123 of 233 sit in a
   tie. Rendered order alone would show those groups in the same sequence to
   everyone forever, which makes the lowest-placed piece in a big group
   effectively invisible.

   The brief is to pick among equal scores at random. That cannot happen in
   Liquid: there is no random filter, and anything seeded from the page is
   frozen by Shopify's full-page cache, so every visitor would get the same
   "random" order. So it happens here, per visit.

   Only EQUAL scores move. A card never crosses a score boundary, so the
   ranking is exactly preserved -- this reorders within each tie group and
   nothing else. Filler cards (the quote cards squaring off a short last row)
   carry no score and are left where they are.

   Runs once per grid, before first paint where possible, and again on
   shopify:section:load so the theme editor sees it too. */
(function () {
  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = list[i]; list[i] = list[j]; list[j] = t;
    }
    return list;
  }

  function rankGrid(grid) {
    if (!grid || grid.dataset.pisShuffled) return;
    grid.dataset.pisShuffled = '1';

    /* Cards in DOM order, each with its score. Anything without one -- a
       filler, a product the sheet has no score for -- is an anchor: it keeps
       its slot and nothing is shuffled across it. */
    var cards = [].slice.call(grid.children);
    var groups = [];
    var current = null;
    cards.forEach(function (el) {
      var raw = el.getAttribute('data-pis');
      if (raw === null || raw === '' || el.hasAttribute('data-cpc-filler')) {
        current = null;
        groups.push({ anchor: el });
        return;
      }
      if (!current || current.score !== raw) {
        current = { score: raw, items: [] };
        groups.push(current);
      }
      current.items.push(el);
    });

    var moved = 0;
    groups.forEach(function (g) {
      if (!g.items || g.items.length < 2) return;
      moved += g.items.length;
      shuffle(g.items);
    });
    if (!moved) return;

    /* Re-append in the new order. Appending an element that is already in the
       DOM moves it, so this is a reorder rather than a rebuild -- event
       listeners, lazy-loading state and the refine bar's own classes survive. */
    var frag = document.createDocumentFragment();
    groups.forEach(function (g) {
      if (g.anchor) { frag.appendChild(g.anchor); return; }
      g.items.forEach(function (el) { frag.appendChild(el); });
    });
    grid.appendChild(frag);

    /* The refine bar restores "Featured" order from data-rb-order, so that
       attribute has to follow the cards or the first filter would undo this. */
    [].slice.call(grid.children).forEach(function (el, i) {
      if (el.hasAttribute('data-rb-order')) el.setAttribute('data-rb-order', i);
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-pgrid]').forEach(rankGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
